import { createContext, useContext, useEffect, useState } from "react";
import { useLazyFetchGet } from "hooks/fetch/useLazyFetchGet";
import { makeQueryString } from "core/makeQueryString";
import PropTypes from "prop-types";

const SimilarCasesContext = createContext({
  fetchSimilarCases: async () => {},
  similarCases: [],
  currentStatus: "All",
  setCurrentStatus: () => {},
  loading: false,
  error: false
});
SimilarCasesContext.displayName = "SimilarCasesContext";

export function SimilarCasesProvider({ children, caseId }) {
  const [similarCases, setSimilarCases] = useState([]);
  const [currentStatus, setCurrentStatus] = useState("All");

  let params = {
    case_id: caseId
  };

  if (currentStatus === "Open") {
    params.open = true;
  } else if (currentStatus === "Closed") {
    params.open = false;
  }

  useEffect(() => {
    getSimilarCases();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStatus]);

  const { loading, error, getCallback: getSimilarCases } = useLazyFetchGet(
    `similar_cases${makeQueryString(params)}`,
    results => setSimilarCases(results),
    () => {}
  );

  return (
    <SimilarCasesContext.Provider
      value={{
        similarCases,
        fetchSimilarCases: getSimilarCases,
        loading,
        error,
        currentStatus,
        setCurrentStatus
      }}
    >
      {children}
    </SimilarCasesContext.Provider>
  );
}

export function useSimilarCasesData() {
  return useContext(SimilarCasesContext);
}

SimilarCasesProvider.propTypes = {
  children: PropTypes.node,
  caseId: PropTypes.number
};
